export default {
  admin: () => import("/app/layouts/admin.vue").then(m => m.default || m),
  auth: () => import("/app/layouts/auth.vue").then(m => m.default || m),
  dashboard: () => import("/app/layouts/dashboard.vue").then(m => m.default || m),
  setup: () => import("/app/layouts/setup.vue").then(m => m.default || m),
  utilities: () => import("/app/layouts/utilities.vue").then(m => m.default || m)
}